import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app'

export default {
  /**
   * Obtiene la lista de multas por exceso de velocidad del residencial
   * @param {Object} params - Filtros opcionales (status, plate, search, etc.)
   * @returns {Promise<Array>} Lista de infracciones/multas
   */
  async getSpeedingFines (params = {}) {
    const url = `${API_BASE}/speed_monitor/fines/`
    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params
      })
      return response.data
    } catch (error) {
      console.error('Error al obtener multas de velocidad:', error)
      throw error
    }
  },

  /**
   * Obtiene los detalles de una multa específica por ID
   * @param {string|number} fineId - ID de la multa
   * @returns {Promise<Object>} Detalle de la multa
   */
  async getFineDetail (fineId) {
    const url = `${API_BASE}/speed_monitor/fines/${fineId}/`
    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error al obtener detalle de la multa:', error)
      throw error
    }
  },

  /**
   * Envía la notificación de la multa al residente vía correo electrónico o SMS
   * @param {string|number} fineId - ID de la multa
   * @param {string} method - 'email' o 'sms'
   * @returns {Promise<Object>} Multa actualizada con nuevo estado
   */
  async sendFine (fineId, method) {
    const url = `${API_BASE}/speed_monitor/fines/${fineId}/send/`
    try {
      const response = await axios.post(url, { method }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error al enviar la multa:', error)
      throw error
    }
  },

  /**
   * Actualiza el estado de una multa (e.g. 'Pagada', 'Enviada', 'Pendiente')
   * @param {string|number} fineId - ID de la multa
   * @param {string} status - Nuevo estado
   * @returns {Promise<Object>} Registro actualizado
   */
  async updateFineStatus (fineId, status) {
    const url = `${API_BASE}/speed_monitor/fines/${fineId}/`
    try {
      const response = await axios.patch(url, { status }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error al actualizar estado de la multa:', error)
      throw error
    }
  },

  /**
   * Registra manualmente o actualiza una infracción
   * @param {Object} fineData - Datos de la multa
   * @returns {Promise<Object>} Registro creado
   */
  async createFine (fineData) {
    const url = `${API_BASE}/speed_monitor/fines/`
    try {
      const response = await axios.post(url, fineData, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error al crear registro de multa:', error)
      throw error
    }
  }
}
